import { View } from 'react-native'
import Animated from 'react-native-reanimated'
import Gradient from '@ui/effects/Gradient'
import useRWD from '@ui/theme/useRWD'
import { colors } from '@ui/colors'
import { topbar } from '@ui/theme/values'
import { useAnimatedOpacity } from '@ui/animated/useAnimatedOpacity'
import { useStagesStore } from 'hooks/useStagesStore'
import { useSession } from 'hooks/useSession'
import { useIsNotFoundRoute } from 'hooks/useIsNotFoundRoute'
import { hex } from '@ui/utils/hex'
import Modal from '@shell/modals/TopbarModal'
import IntroBrands from '@screens/intro/deals/Header/Brands'
import CartButton from '@shell/CartButton'

import BackButton from './buttons/BackButton'
import Stages from './stages/Stages'
import Dropdown from './dropdown/Dropdown'
import { Test } from './stages/helpers'
import { Preset } from './types'

const height = topbar.height
const paddingSide = 16

function Background() {
  const preset = useStagesStore((state) => state.preset)

  const presetBackground: Record<Preset, boolean> = {
    empty: false,
    intro: false,
    deals: false,
    staff: true,
    customer: true,
    main: true,
    avatar: true,
    dev: true,
  }

  const styleOpacity = useAnimatedOpacity(!!presetBackground[preset])

  return (
    <>
      <Gradient
        colors={[
          colors.white,
          hex(colors.white, 0.95),
          colors.white50,
          colors.white0,
        ]}
        start={[0.5, 0]}
        end={[0.5, 1]}
        style={[styleOpacity, { height }]}
      />
    </>
  )
}

function Container({ children }: { children: React.ReactNode }) {
  const { screen } = useRWD()

  return (
    <View
      className="absolute inset-0 flex-row items-center justify-between"
      style={{ height, width: screen.width }}
    >
      {children}
    </View>
  )
}

function Logos() {
  const isLogo = useStagesStore((state) => state.isLogo)
  const pendingOrder = useSession((s) => s.pendingOrder)
  const pendingType = pendingOrder?.deal.filter?.type
  const styleOpacity = useAnimatedOpacity(isLogo)

  return (
    <Animated.View
      className="absolute inset-0 flex w-full flex-row items-center justify-center"
      style={[styleOpacity, { paddingTop: 48, paddingHorizontal: 128 }]}
    >
      <IntroBrands types={pendingType ? [pendingType] : undefined} />
    </Animated.View>
  )
}

export default function Topbar() {
  const isNotFoundRoute = useIsNotFoundRoute()

  if (isNotFoundRoute) {
    return null
  }

  return (
    <>
      <Background />
      <Container>
        <Stages />
        <Logos />
        <View style={{ paddingLeft: paddingSide }}>
          <BackButton />
        </View>
        <View
          className="flex flex-row items-center justify-end gap-4"
          style={{ paddingRight: paddingSide }}
        >
          <CartButton />
          <Dropdown />
        </View>
      </Container>
      <Test />
      <Modal />
    </>
  )
}
